<template>
  <div v-if="show" class="update-firebase-modal">
    <div class="update-firebase-modal__overlay" @click="$emit('close')"></div>

    <div class="update-firebase-modal__modal">
      <div class="header">
        <button class="close-btn" @click="$emit('close')">
          <svg width="16" height="16" viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M12 4L4 12M4 4L12 12" stroke="#666" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </button>
      </div>

      <div class="content-modal">
        <div class="icon-container">
          <svg width="64" height="64" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" class="icon">
            <path d="M12 2L2 7L12 12L22 7L12 2Z" stroke="#423799" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2 17L12 22L22 17" stroke="#423799" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
            <path d="M2 12L12 17L22 12" stroke="#423799" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/>
          </svg>
        </div>

        <h2 class="modal-title">Update from Firebase to API</h2>
        <p class="modal-description">
          This will update all missing race resumes from Firebase data. The process will check each runner and create race resumes for those that don't exist.
        </p>

        <div class="toggle-container">
          <label class="toggle-label">
            <input 
              type="checkbox" 
              v-model="overwriteExisting"
              class="toggle-checkbox"
            />
            <span class="toggle-text">Overwrite existing race resumes if found</span>
          </label>
        </div>

        <div class="button-container">
          <button 
            type="button" 
            class="btn btn--gray" 
            @click="$emit('close')"
            :disabled="loading"
          >
            Cancel
          </button>
          <button 
            type="button" 
            class="btn btn--primary" 
            @click="handleConfirm"
            :disabled="loading"
          >
            <span v-if="loading" class="btn-loader"></span>
            <span>{{ loading ? 'Processing...' : 'Update' }}</span>
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: 'UpdateFromFirebaseModal',
  props: {
    show: {
      type: Boolean,
      default: false
    },
    raceId: {
      type: Number,
      default: null
    },
    loading: {
      type: Boolean,
      default: false
    }
  },
  data: () => ({
    overwriteExisting: false
  }),
  methods: {
    handleConfirm() {
      this.$emit('confirm', {
        overwriteExisting: this.overwriteExisting
      })
    }
  },
  watch: {
    show(newVal) {
      if (!newVal) {
        // Reset form when modal closes
        this.overwriteExisting = false
      }
    }
  }
}
</script>

<style lang="stylus" scoped>
  .update-firebase-modal
    &__overlay
      position fixed
      top 0
      left 0
      right 0
      bottom 0
      background rgba(#000, 0.45)
      z-index 80000

    &__modal
      position fixed
      top 50%
      left 50%
      padding 30px
      transform translateX(-50%) translateY(-50%)
      width 500px
      max-width 90vw
      z-index 90000
      background #ffffff
      border-radius 8px
      box-shadow 0 4px 20px rgba(0, 0, 0, 0.15)

      .header
        position relative
        margin-bottom 10px

        .close-btn
          position absolute
          top 0
          right 0
          background none
          border none
          padding 0
          cursor pointer
          display flex
          align-items center
          justify-content center
          width 24px
          height 24px
          transition opacity 0.2s

          &:hover
            opacity 0.7

          svg
            display block

      .content-modal
        text-align center

        .icon-container
          margin-bottom 20px
          display flex
          justify-content center

          .icon
            color #423799

        .modal-title
          font-size 24px
          font-weight 600
          color #333
          margin-bottom 12px

        .modal-description
          font-size 14px
          color #666
          line-height 1.6
          margin-bottom 24px
          text-align left

        .toggle-container
          margin-bottom 24px
          text-align left
          padding 16px
          background-color #f8f9fa
          border-radius 4px

          .toggle-label
            display flex
            align-items center
            cursor pointer
            user-select none

            .toggle-checkbox
              width 20px
              height 20px
              margin-right 12px
              cursor pointer

            .toggle-text
              font-size 14px
              color #333
              font-weight 500

        .button-container
          display flex
          gap 12px
          justify-content flex-end
          align-items center

          .btn
            min-width 100px
            padding 10px 20px
            border-radius 4px
            font-weight 500
            cursor pointer
            transition all 0.2s
            display flex
            align-items center
            justify-content center
            line-height 1
            height auto

            &:disabled
              opacity 0.6
              cursor not-allowed

            &.btn--primary
              background-color #423799
              color #fff
              border none

              &:hover:not(:disabled)
                background-color #352a7a

            &.btn--gray
              background-color #f1f1f1
              color #333
              border 1px solid #ddd

              &:hover:not(:disabled)
                background-color #e1e1e1

          .btn-loader
            display inline-block
            width 14px
            height 14px
            margin-right 8px
            border 2px solid rgba(255, 255, 255, 0.3)
            border-top-color #fff
            border-radius 50%
            animation spin 0.8s linear infinite

        @keyframes spin
          to
            transform rotate(360deg)
</style>




// WEBPACK FOOTER //
// UpdateFromFirebaseModal.vue?798c5873